(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-helpful"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__hchInit) return;
    window.__hchInit = true;

    var PREFIX = 'hch:v1:';

    function loadVote(key) {
      try {
        var v = window.localStorage.getItem(PREFIX + key);
        return v === 'yes' || v === 'no' ? v : null;
      } catch (err) { return null; }
    }
    function saveVote(key, v) {
      try {
        if (v) window.localStorage.setItem(PREFIX + key, v);
        else window.localStorage.removeItem(PREFIX + key);
      } catch (err) { /* private mode: the vote is simply not remembered */ }
    }

    /* New counts after a visitor votes (or changes their vote) */
    function applyVote(counts, prev, next) {
      var c = { yes: counts.yes, no: counts.no };
      if (prev === next) return c;
      if (prev === 'yes' || prev === 'no') c[prev] = Math.max(0, c[prev] - 1);
      if (next === 'yes' || next === 'no') c[next] += 1;
      return c;
    }

    function toCounts(data) {
      var y = parseInt(data && data.yes, 10);
      var n = parseInt(data && data.no, 10);
      return { yes: y > 0 ? y : 0, no: n > 0 ? n : 0 };
    }

    /* [yes] [no] [total] [percent] are replaced in the counter text */
    function format(template, counts) {
      var total = counts.yes + counts.no;
      var percent = total > 0 ? Math.round((counts.yes / total) * 100) : 0;
      return String(template)
        .replace(/\[yes\]/g, String(counts.yes))
        .replace(/\[no\]/g, String(counts.no))
        .replace(/\[total\]/g, String(total))
        .replace(/\[percent\]/g, String(percent));
    }

    window.__hch = { applyVote: applyVote, toCounts: toCounts, format: format };

    function stateOf(root) {
      if (!root.__hch) {
        root.__hch = { counts: null, vote: loadVote(root.getAttribute('data-key')), busy: false, error: false };
      }
      return root.__hch;
    }

    function render(root) {
      var st = stateOf(root);

      var buttons = root.querySelectorAll('[data-hch-vote]');
      Array.prototype.forEach.call(buttons, function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-hch-vote') === st.vote ? 'true' : 'false');
      });

      var thanks = root.querySelector('[data-hch-thanks]');
      var msg = st.error ? root.getAttribute('data-error') : (st.vote ? root.getAttribute('data-thanks') : '');
      thanks.textContent = msg || '';
      thanks.hidden = !msg;
      thanks.classList.toggle('hch__thanks--error', !!st.error);

      var count = root.querySelector('[data-hch-count]');
      var line = '';
      if (st.counts && root.getAttribute('data-show-counter') === 'true') {
        var total = st.counts.yes + st.counts.no;
        line = total === 0
          ? root.getAttribute('data-empty-text')
          : format(root.getAttribute('data-counter-text'), st.counts);
      }
      count.textContent = line || '';
      count.hidden = !line;
    }

    function loadCounts(root) {
      var st = stateOf(root);
      var endpoint = root.getAttribute('data-endpoint');
      if (!endpoint) {
        /* In the theme editor, show sample numbers so the layout can be checked */
        if (root.getAttribute('data-preview') === 'true') st.counts = { yes: 12, no: 3 };
        render(root);
        return;
      }
      var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'article=' + encodeURIComponent(root.getAttribute('data-key'));
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.json(); })
        .then(function (data) { st.counts = toCounts(data); render(root); })
        .catch(function () { render(root); });
    }

    function castVote(root, next) {
      var st = stateOf(root);
      if (st.busy || st.vote === next) return;
      var key = root.getAttribute('data-key');
      var prev = st.vote;
      var before = st.counts ? { yes: st.counts.yes, no: st.counts.no } : null;

      st.vote = next;
      st.error = false;
      saveVote(key, next);
      if (st.counts) st.counts = applyVote(st.counts, prev, next);
      render(root);

      var endpoint = root.getAttribute('data-endpoint');
      if (!endpoint) return;

      st.busy = true;
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ article: key, vote: next, previous: prev })
      })
        .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.json(); })
        .then(function (data) { st.counts = toCounts(data); st.busy = false; render(root); })
        .catch(function () {
          st.busy = false;
          st.vote = prev;
          st.counts = before;
          st.error = true;
          saveVote(key, prev);
          render(root);
        });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hch]');
      Array.prototype.forEach.call(roots, function (root) {
        if (root.__hchReady) return;
        root.__hchReady = true;
        loadCounts(root);
      });
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-hch-vote]');
      if (!btn) return;
      var root = btn.closest('[data-hch]');
      if (root) castVote(root, btn.getAttribute('data-hch-vote'));
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__hcCardsInit) return;
    window.__hcCardsInit = true;

    function norm(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    document.addEventListener('hc:search', function (e) {
      var term = norm(((e.detail && e.detail.term) || '').trim());
      var grids = document.querySelectorAll('[data-hc-cards]');
      Array.prototype.forEach.call(grids, function (grid) {
        var shown = 0;
        var cards = grid.querySelectorAll('[data-hc-card]');
        Array.prototype.forEach.call(cards, function (card) {
          var ok = !term || norm(card.getAttribute('data-hc-text')).indexOf(term) !== -1;
          card.hidden = !ok;
          if (ok) shown++;
        });
        var results = grid.parentNode;
        var empty = results ? results.querySelector('[data-hc-empty]') : null;
        if (empty) empty.hidden = !(term && cards.length > 0 && shown === 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__blogCategoriesInit) return;
    window.__blogCategoriesInit = true;

    function norm(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    /* Grid / list toggle */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-hcg-view]');
      if (!btn) return;
      var root = btn.closest('.hcg');
      if (!root) return;
      var view = btn.getAttribute('data-hcg-view');
      if (view === 'list') root.classList.add('hcg--list');
      else root.classList.remove('hcg--list');
      var btns = root.querySelectorAll('[data-hcg-view]');
      Array.prototype.forEach.call(btns, function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-hcg-view') === view ? 'true' : 'false');
      });
    });

    /* "hc:search" is sent by the Blog Search section */
    document.addEventListener('hc:search', function (e) {
      var term = norm(((e.detail && e.detail.term) || '').trim());
      var boxes = document.querySelectorAll('[data-hcg-results]');
      Array.prototype.forEach.call(boxes, function (box) {
        var shown = 0;
        var cards = box.querySelectorAll('[data-hcg-card]');
        Array.prototype.forEach.call(cards, function (card) {
          var ok = !term || norm(card.getAttribute('data-hcg-text')).indexOf(term) !== -1;
          card.hidden = !ok;
          if (ok) shown++;
        });
        var empty = box.querySelector('[data-hcg-empty]');
        if (empty) empty.hidden = !(term && cards.length > 0 && shown === 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-icon-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__blogIconCardsInit) return;
    window.__blogIconCardsInit = true;

    function norm(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    /* "hc:search" is sent by the Blog Search section */
    document.addEventListener('hc:search', function (e) {
      var term = norm(((e.detail && e.detail.term) || '').trim());
      var boxes = document.querySelectorAll('[data-hci-results]');
      Array.prototype.forEach.call(boxes, function (box) {
        var shown = 0;
        var cards = box.querySelectorAll('[data-hci-card]');
        Array.prototype.forEach.call(cards, function (card) {
          var ok = !term || norm(card.getAttribute('data-hci-text')).indexOf(term) !== -1;
          card.hidden = !ok;
          if (ok) shown++;
        });
        var empty = box.querySelector('[data-hci-empty]');
        if (empty) empty.hidden = !(term && cards.length > 0 && shown === 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__hcSearchInit) return;
    window.__hcSearchInit = true;

    function send(term) {
      document.dispatchEvent(new CustomEvent('hc:search', { detail: { term: term } }));
    }

    /* ---------- Dropdown helpers ---------- */
    function norm(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function clip(text, max) {
      var t = String(text || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      return t.length > max ? t.slice(0, max - 3).replace(/\s+\S*$/, '') + '...' : t;
    }

    function matchBlogs(blogs, term, max) {
      var q = norm(term).trim();
      if (!q) return [];
      return blogs.filter(function (b) { return norm(b.title).indexOf(q) !== -1; }).slice(0, max);
    }

    function parseArticles(data, max) {
      var list = data && data.resources && data.resources.results && data.resources.results.articles;
      if (!list || !list.length) return [];
      return list.slice(0, max).map(function (a) {
        return { title: a.title || '', url: a.url || '#', text: clip(a.body, 110) };
      });
    }

    window.__hcs = { norm: norm, clip: clip, matchBlogs: matchBlogs, parseArticles: parseArticles };

    function stateOf(form) {
      if (!form.__hcs) {
        var blogs = [];
        var el = form.querySelector('[data-hcs-blogs]');
        if (el) { try { blogs = JSON.parse(el.textContent) || []; } catch (err) { blogs = []; } }
        form.__hcs = { blogs: blogs, token: 0, timer: null, ctrl: null, active: -1 };
      }
      return form.__hcs;
    }

    function enabled(form) {
      return form.getAttribute('data-hcs-suggest') === 'true' && !!form.querySelector('[data-hcs-panel]');
    }

    function setOpen(form, open) {
      var panel = form.querySelector('[data-hcs-panel]');
      var input = form.querySelector('[data-hc-search-input]');
      if (!panel) return;
      panel.hidden = !open;
      if (input) {
        input.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) input.removeAttribute('aria-activedescendant');
      }
      if (!open) stateOf(form).active = -1;
    }

    function setActive(form, index) {
      var panel = form.querySelector('[data-hcs-panel]');
      var input = form.querySelector('[data-hc-search-input]');
      var opts = panel.querySelectorAll('[role="option"]');
      var st = stateOf(form);
      Array.prototype.forEach.call(opts, function (o) { o.removeAttribute('aria-selected'); });
      if (index < 0 || index >= opts.length) {
        st.active = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      st.active = index;
      opts[index].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[index].id);
      if (opts[index].scrollIntoView) opts[index].scrollIntoView({ block: 'nearest' });
    }

    function group(panel, label) {
      var h = document.createElement('p');
      h.className = 'hcs__group';
      h.setAttribute('role', 'presentation');
      h.textContent = label;
      panel.appendChild(h);
    }

    function option(panel, item, showText, n) {
      var a = document.createElement('a');
      a.className = 'hcs__opt';
      a.setAttribute('role', 'option');
      a.setAttribute('tabindex', '-1');
      a.href = item.url;
      a.id = panel.id + '-' + n;
      var t = document.createElement('span');
      t.className = 'hcs__opt-title';
      t.textContent = item.title;
      a.appendChild(t);
      if (showText && item.text) {
        var d = document.createElement('span');
        d.className = 'hcs__opt-text';
        d.textContent = item.text;
        a.appendChild(d);
      }
      panel.appendChild(a);
    }

    function render(form, blogs, articles, pending) {
      var panel = form.querySelector('[data-hcs-panel]');
      var showText = form.getAttribute('data-hcs-excerpt') === 'true';
      while (panel.firstChild) panel.removeChild(panel.firstChild);
      var n = 0;
      if (blogs.length) {
        group(panel, form.getAttribute('data-hcs-blogs-label') || 'Blogs');
        blogs.forEach(function (b) { option(panel, { title: b.title, url: b.url, text: '' }, false, n++); });
      }
      if (articles.length) {
        group(panel, form.getAttribute('data-hcs-articles-label') || 'Articles');
        articles.forEach(function (a) { option(panel, a, showText, n++); });
      }
      if (!n) {
        if (pending) { setOpen(form, false); return; }
        var p = document.createElement('p');
        p.className = 'hcs__empty';
        p.setAttribute('role', 'status');
        p.textContent = form.getAttribute('data-hcs-empty') || 'No results found';
        panel.appendChild(p);
      }
      stateOf(form).active = -1;
      setOpen(form, true);
    }

    function suggest(form, term) {
      var st = stateOf(form);
      var q = String(term || '').trim();
      clearTimeout(st.timer);
      if (st.ctrl) { try { st.ctrl.abort(); } catch (err) { /* nothing to cancel */ } st.ctrl = null; }
      st.token += 1;
      var token = st.token;
      if (q.length < 2) { setOpen(form, false); return; }

      var max = parseInt(form.getAttribute('data-hcs-max'), 10) || 5;
      var blogs = matchBlogs(st.blogs, q, max);
      render(form, blogs, [], true);

      st.timer = setTimeout(function () {
        var base = form.getAttribute('data-hcs-url') || '/search/suggest';
        var url = base + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=article&resources[limit]=' + max +
          '&resources[options][fields]=title,body,author,tag';
        var ctrl = window.AbortController ? new AbortController() : null;
        st.ctrl = ctrl;
        fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.json(); })
          .then(function (data) {
            if (token !== st.token) return;
            render(form, blogs, parseArticles(data, max), false);
          })
          .catch(function (err) {
            if (token !== st.token || (err && err.name === 'AbortError')) return;
            render(form, blogs, [], false);
          });
      }, 200);
    }

    /* ---------- Events ---------- */
    document.addEventListener('input', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('[data-hc-search-input]') : null;
      if (!input || !input.form) return;
      if (input.form.getAttribute('data-hc-mode') !== 'site') send(input.value);
      if (enabled(input.form)) suggest(input.form, input.value);
    });

    document.addEventListener('keydown', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('[data-hc-search-input]') : null;
      if (!input || !input.form || !enabled(input.form)) return;
      var form = input.form;
      var panel = form.querySelector('[data-hcs-panel]');
      var opts = panel.querySelectorAll('[role="option"]');
      var st = stateOf(form);
      if (e.key === 'Escape') {
        if (!panel.hidden) { setOpen(form, false); e.preventDefault(); }
      } else if (e.key === 'ArrowDown' && opts.length) {
        e.preventDefault();
        if (panel.hidden) setOpen(form, true);
        setActive(form, st.active + 1 >= opts.length ? 0 : st.active + 1);
      } else if (e.key === 'ArrowUp' && opts.length) {
        e.preventDefault();
        if (panel.hidden) setOpen(form, true);
        setActive(form, st.active <= 0 ? opts.length - 1 : st.active - 1);
      } else if (e.key === 'Enter' && !panel.hidden && st.active >= 0 && opts[st.active]) {
        e.preventDefault();
        window.location.href = opts[st.active].href;
      }
    });

    document.addEventListener('focusin', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('[data-hc-search-input]') : null;
      if (!input || !input.form || !enabled(input.form)) return;
      var panel = input.form.querySelector('[data-hcs-panel]');
      if (panel.hidden && panel.firstChild && input.value.trim().length >= 2) setOpen(input.form, true);
    });

    document.addEventListener('click', function (e) {
      var open = document.querySelectorAll('[data-hcs-panel]:not([hidden])');
      Array.prototype.forEach.call(open, function (panel) {
        var form = panel.closest('form');
        if (form && !form.contains(e.target)) setOpen(form, false);
      });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      if (enabled(form)) setOpen(form, false);
      if (form.getAttribute('data-hc-mode') !== 'filter') return;
      e.preventDefault();
      var input = form.querySelector('[data-hc-search-input]');
      send(input ? input.value : '');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["click-popups"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__hcpClickInit) return;
    window.__hcpClickInit = true;

    var root = document.documentElement;

    function dialogOf(el) {
      var wrap = el && el.closest ? el.closest('.hcp') : null;
      return wrap ? wrap.querySelector('.hcp__dialog') : null;
    }
    function pagesOf(d) {
      return Array.prototype.slice.call(d.querySelectorAll('.hcp__page'));
    }
    function findPage(d, key) {
      var pages = pagesOf(d);
      for (var i = 0; i < pages.length; i++) {
        if (pages[i].getAttribute('data-hcp-page') === key) return pages[i];
      }
      return null;
    }
    function stackOf(d) {
      if (!d.__hcpStack) d.__hcpStack = [];
      return d.__hcpStack;
    }
    /* Email form: back to its starting state every time a popup opens or closes */
    function resetForms(d) {
      Array.prototype.forEach.call(d.querySelectorAll('[data-hcp-form]'), function (f) {
        var fields = f.querySelector('[data-hcp-fields]');
        var ok = f.querySelector('[data-hcp-success]');
        var err = f.querySelector('[data-hcp-error]');
        var btn = f.querySelector('[data-hcp-submit]');
        var pg = f.closest('.hcp__page');
        if (pg) pg.classList.remove('hcp__page--sent');
        if (fields) fields.hidden = false;
        if (ok) ok.hidden = true;
        if (err) { err.hidden = true; err.textContent = ''; }
        if (btn) btn.disabled = false;
      });
    }
    /* What the visitor was reading before the form, for example "Which knife is right for me? > Single Knife" */
    function topicOf(d) {
      var titles = [];
      stackOf(d).forEach(function (p) {
        var t = p.getAttribute('data-hcp-title');
        if (t) titles.push(t);
      });
      if (titles.length > 1) titles.pop();
      return titles.join(' > ');
    }
    function unlock() {
      if (!document.querySelector('.hcp__dialog[open]')) root.classList.remove('hcp-lock');
    }

    /* Show the last page of the history and update the back arrow */
    function render(d, focus) {
      var stack = stackOf(d);
      var current = stack[stack.length - 1];
      pagesOf(d).forEach(function (p) { p.hidden = p !== current; });
      var back = d.querySelector('.hcp__back');
      if (back) back.hidden = stack.length < 2;
      var panel = d.querySelector('.hcp__panel');
      if (panel) panel.scrollTop = 0;
      if (focus && current) {
        try { current.focus({ preventScroll: true }); } catch (err) {}
      }
    }

    function openAt(d, key) {
      if (!d) return;
      var page = findPage(d, key);
      if (!page) return;
      d.__hcpStack = [page];
      resetForms(d);
      if (typeof d.showModal === 'function') {
        if (!d.open) d.showModal();
      } else {
        d.setAttribute('open', '');
      }
      root.classList.add('hcp-lock');
      render(d, true);
    }
    function goTo(d, key) {
      if (!d) return;
      var page = findPage(d, key);
      if (!page) return;
      stackOf(d).push(page);
      render(d, true);
    }
    function goBack(d) {
      if (!d) return;
      var stack = stackOf(d);
      if (stack.length > 1) {
        stack.pop();
        render(d, true);
      }
    }
    function closeDialog(d) {
      if (!d) return;
      d.__hcpStack = [];
      resetForms(d);
      if (typeof d.close === 'function') d.close();
      else d.removeAttribute('open');
      unlock();
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var el = t.closest('[data-hcp-open]');
      if (el) { openAt(dialogOf(el), el.getAttribute('data-hcp-open')); return; }
      el = t.closest('[data-hcp-goto]');
      if (el) { goTo(dialogOf(el), el.getAttribute('data-hcp-goto')); return; }
      el = t.closest('[data-hcp-back]');
      if (el) { goBack(dialogOf(el)); return; }
      el = t.closest('[data-hcp-close]');
      if (el) { closeDialog(dialogOf(el)); return; }
      if (t.tagName === 'DIALOG' && t.classList.contains('hcp__dialog')) closeDialog(t);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-hcp-form')) return;
      e.preventDefault();
      var d = dialogOf(form);
      var action = form.getAttribute('data-action') || '';
      var err = form.querySelector('[data-hcp-error]');
      var btn = form.querySelector('[data-hcp-submit]');
      function fail() {
        err.textContent = form.getAttribute('data-error-text') || 'We could not send your request. Please try again.';
        err.hidden = false;
        btn.disabled = false;
      }
      err.hidden = true;
      if (!action) { fail(); return; }
      var data = new FormData(form);
      data.set('topic', topicOf(d));
      data.set('page', window.location.href);
      btn.disabled = true;
      fetch(action, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, json: j }; }, function () { return { ok: false, json: null }; });
        })
        .then(function (res) {
          if (!res.ok || !res.json || !res.json.ok) { fail(); return; }
          form.reset();
          form.querySelector('[data-hcp-fields]').hidden = true;
          form.querySelector('[data-hcp-success]').hidden = false;
          var page = form.closest('.hcp__page');
          if (page) page.classList.add('hcp__page--sent');
        })
        .catch(fail);
    });

    /* Esc key: the close event does not bubble, so listen in the capture phase */
    document.addEventListener('close', function (e) {
      var d = e.target;
      if (d && d.classList && d.classList.contains('hcp__dialog')) {
        d.__hcpStack = [];
        unlock();
      }
    }, true);

    /* Theme editor: selecting an item or page opens it */
    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      if (!el || !el.getAttribute) return;
      var key = el.getAttribute('data-hcp-open') || el.getAttribute('data-hcp-page');
      if (key) openAt(dialogOf(el), key);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var el = e.target;
      if (el && el.getAttribute && (el.getAttribute('data-hcp-open') || el.getAttribute('data-hcp-page'))) {
        closeDialog(dialogOf(el));
      }
    });
    document.addEventListener('shopify:section:unload', function () {
      setTimeout(unlock, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__hcfInit) return;
    window.__hcfInit = true;

    function keyOf(f) { return f.name + '|' + f.size + '|' + f.lastModified; }

    /* Adds new files to the current list, skipping duplicates, oversized files and anything over the limit */
    function mergeFiles(current, incoming, maxFiles, maxMb) {
      var maxBytes = maxMb * 1048576;
      var files = current.slice();
      var errors = [];
      var seen = {};
      var countError = false;
      files.forEach(function (f) { seen[keyOf(f)] = true; });
      Array.prototype.forEach.call(incoming, function (f) {
        if (seen[keyOf(f)]) return;
        if (f.size > maxBytes) {
          errors.push('"' + f.name + '" is larger than ' + maxMb + ' MB.');
          return;
        }
        if (files.length >= maxFiles) {
          if (!countError) {
            errors.push('You can attach up to ' + maxFiles + ' files.');
            countError = true;
          }
          return;
        }
        seen[keyOf(f)] = true;
        files.push(f);
      });
      return { files: files, errors: errors };
    }
    window.__hcf = { merge: mergeFiles };

    function formatSize(n) {
      if (n < 1024) return n + ' B';
      if (n < 1048576) return Math.round(n / 1024) + ' KB';
      return (n / 1048576).toFixed(1) + ' MB';
    }

    function rootOf(el) {
      return el && el.closest ? el.closest('[data-hcf-attach]') : null;
    }

    function showErrors(root, errors) {
      var box = root.querySelector('[data-hcf-error]');
      if (!box) return;
      box.textContent = errors.join(' ');
      box.hidden = errors.length === 0;
    }

    function render(root) {
      var files = root.__hcfFiles || [];
      var input = root.querySelector('[data-hcf-input]');
      try {
        var dt = new DataTransfer();
        files.forEach(function (f) { dt.items.add(f); });
        input.files = dt.files;
      } catch (err) { /* very old browsers: only the last selection is sent */ }

      var list = root.querySelector('[data-hcf-files]');
      while (list.firstChild) list.removeChild(list.firstChild);
      files.forEach(function (f, i) {
        var li = document.createElement('li');
        li.className = 'hcf__file-item';
        var name = document.createElement('span');
        name.className = 'hcf__file-name';
        name.textContent = f.name;
        var size = document.createElement('span');
        size.className = 'hcf__file-size';
        size.textContent = formatSize(f.size);
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'hcf__file-remove';
        rm.setAttribute('data-hcf-remove', String(i));
        rm.setAttribute('aria-label', 'Remove ' + f.name);
        rm.textContent = '\u00d7';
        li.appendChild(name);
        li.appendChild(size);
        li.appendChild(rm);
        list.appendChild(li);
      });
    }

    function addFiles(root, incoming) {
      var max = parseInt(root.getAttribute('data-max-files'), 10) || 10;
      var mb = parseFloat(root.getAttribute('data-max-mb')) || 10;
      var res = mergeFiles(root.__hcfFiles || [], incoming, max, mb);
      root.__hcfFiles = res.files;
      render(root);
      showErrors(root, res.errors);
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var pick = t.closest('[data-hcf-pick]');
      if (pick) {
        var r = rootOf(pick);
        var input = r && r.querySelector('[data-hcf-input]');
        if (input) input.click();
        return;
      }
      var rm = t.closest('[data-hcf-remove]');
      if (rm) {
        var root = rootOf(rm);
        if (!root) return;
        var idx = parseInt(rm.getAttribute('data-hcf-remove'), 10);
        var files = (root.__hcfFiles || []).slice();
        files.splice(idx, 1);
        root.__hcfFiles = files;
        render(root);
        showErrors(root, []);
      }
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-hcf-input]')) return;
      var root = rootOf(t);
      if (!root) return;
      addFiles(root, Array.prototype.slice.call(t.files || []));
    });

    document.addEventListener('dragover', function (e) {
      var zone = e.target && e.target.closest ? e.target.closest('[data-hcf-pick]') : null;
      if (!zone) return;
      e.preventDefault();
      zone.classList.add('is-over');
    });
    document.addEventListener('dragleave', function (e) {
      var zone = e.target && e.target.closest ? e.target.closest('[data-hcf-pick]') : null;
      if (zone) zone.classList.remove('is-over');
    });
    document.addEventListener('drop', function (e) {
      var zone = e.target && e.target.closest ? e.target.closest('[data-hcf-pick]') : null;
      if (!zone) return;
      e.preventDefault();
      zone.classList.remove('is-over');
      var root = rootOf(zone);
      if (root && e.dataTransfer) addFiles(root, Array.prototype.slice.call(e.dataTransfer.files || []));
    });

    /* Avoid double sending */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('hcf__form')) return;
      var btn = form.querySelector('.hcf__send');
      if (!btn) return;
      setTimeout(function () {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }, 0);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var btns = document.querySelectorAll('.hcf__send');
      Array.prototype.forEach.call(btns, function (b) {
        b.disabled = false;
        b.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  /* Product suggestions under the header search bar */
  (function () {
    if (window.__hdrSuggestInit) return;
    window.__hdrSuggestInit = true;

    function money(value, currency, locale) {
      var n = parseFloat(value);
      if (isNaN(n)) return '';
      try {
        return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency || 'USD' }).format(n);
      } catch (err) {
        return (currency || '') + ' ' + n.toFixed(2);
      }
    }

    function parseProducts(data, max) {
      var list = data && data.resources && data.resources.results && data.resources.results.products;
      if (!list || !list.length) return [];
      return list
        .filter(function (p) { return !(p.tags && p.tags.indexOf('search-hidden') !== -1); })
        .slice(0, max)
        .map(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var price = parseFloat(p.price);
          var compare = parseFloat(p.compare_at_price_max);
          return {
            title: p.title || '',
            url: p.url || '#',
            image: img,
            price: p.price,
            compare: compare > price ? p.compare_at_price_max : '',
            available: p.available !== false
          };
        });
    }

    window.__hdrSuggest = { parseProducts: parseProducts, money: money };

    function stateOf(form) {
      if (!form.__hdr) form.__hdr = { token: 0, timer: null, ctrl: null, active: -1 };
      return form.__hdr;
    }
    function enabled(form) {
      return form.getAttribute('data-hdr-suggest') === 'true' && !!form.querySelector('[data-hdr-panel]');
    }
    function setOpen(form, open) {
      var panel = form.querySelector('[data-hdr-panel]');
      var input = form.querySelector('input[type="search"]');
      panel.hidden = !open;
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) { input.removeAttribute('aria-activedescendant'); stateOf(form).active = -1; }
    }
    function setActive(form, index) {
      var panel = form.querySelector('[data-hdr-panel]');
      var input = form.querySelector('input[type="search"]');
      var opts = panel.querySelectorAll('[role="option"]');
      Array.prototype.forEach.call(opts, function (o) { o.removeAttribute('aria-selected'); });
      if (index < 0 || index >= opts.length) { stateOf(form).active = -1; input.removeAttribute('aria-activedescendant'); return; }
      stateOf(form).active = index;
      opts[index].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[index].id);
      if (opts[index].scrollIntoView) opts[index].scrollIntoView({ block: 'nearest' });
    }

    function span(cls, text) {
      var el = document.createElement('span');
      el.className = cls;
      el.textContent = text;
      return el;
    }

    function render(form, products, term) {
      var panel = form.querySelector('[data-hdr-panel]');
      var currency = form.getAttribute('data-hdr-currency');
      var locale = form.getAttribute('data-hdr-locale');
      while (panel.firstChild) panel.removeChild(panel.firstChild);

      if (!products.length) {
        var p = document.createElement('p');
        p.className = 'hdr-sg__empty';
        p.setAttribute('role', 'status');
        p.textContent = (form.getAttribute('data-hdr-empty') || 'No products found for') + ' "' + term + '"';
        panel.appendChild(p);
      } else {
        products.forEach(function (item, i) {
          var a = document.createElement('a');
          a.className = 'hdr-sg';
          a.setAttribute('role', 'option');
          a.setAttribute('tabindex', '-1');
          a.id = 'hdr-sg-' + i;
          a.href = item.url;
          if (item.image) {
            var img = document.createElement('img');
            img.className = 'hdr-sg__img';
            img.alt = '';
            img.width = 56;
            img.height = 56;
            img.loading = 'lazy';
            img.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=112';
            a.appendChild(img);
          }
          var body = document.createElement('span');
          body.className = 'hdr-sg__body';
          body.appendChild(span('hdr-sg__title', item.title));
          var meta = document.createElement('span');
          meta.className = 'hdr-sg__meta';
          meta.appendChild(span('hdr-sg__price', money(item.price, currency, locale)));
          if (item.compare) meta.appendChild(span('hdr-sg__compare', money(item.compare, currency, locale)));
          if (!item.available) meta.appendChild(span('hdr-sg__sold', 'Sold out'));
          body.appendChild(meta);
          a.appendChild(body);
          panel.appendChild(a);
        });
        var all = document.createElement('a');
        all.className = 'hdr-sg__all';
        all.setAttribute('role', 'option');
        all.setAttribute('tabindex', '-1');
        all.id = 'hdr-sg-all';
        all.href = form.getAttribute('action') + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
        all.textContent = (form.getAttribute('data-hdr-all') || 'See all results for') + ' "' + term + '"';
        panel.appendChild(all);
      }
      stateOf(form).active = -1;
      setOpen(form, true);
    }

    function suggest(form, term) {
      var st = stateOf(form);
      var q = String(term || '').trim();
      clearTimeout(st.timer);
      if (st.ctrl) { try { st.ctrl.abort(); } catch (err) { /* nothing to cancel */ } st.ctrl = null; }
      st.token += 1;
      var token = st.token;
      if (q.length < 2) { setOpen(form, false); return; }
      var max = parseInt(form.getAttribute('data-hdr-max'), 10) || 6;
      st.timer = setTimeout(function () {
        var base = form.getAttribute('data-hdr-url') || '/search/suggest';
        var url = base + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=' + Math.min(max + 4, 10) +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        var ctrl = window.AbortController ? new AbortController() : null;
        st.ctrl = ctrl;
        fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.json(); })
          .then(function (data) { if (token === st.token) render(form, parseProducts(data, max), q); })
          .catch(function (err) {
            if (token !== st.token || (err && err.name === 'AbortError')) return;
            setOpen(form, false);
          });
      }, 200);
    }

    document.addEventListener('input', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('.hdr-search__input') : null;
      if (input && input.form && enabled(input.form)) suggest(input.form, input.value);
    });

    document.addEventListener('keydown', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('.hdr-search__input') : null;
      if (!input || !input.form || !enabled(input.form)) return;
      var form = input.form;
      var panel = form.querySelector('[data-hdr-panel]');
      var opts = panel.querySelectorAll('[role="option"]');
      var st = stateOf(form);
      if (e.key === 'Escape') {
        if (!panel.hidden) { setOpen(form, false); e.preventDefault(); }
      } else if (e.key === 'ArrowDown' && opts.length) {
        e.preventDefault();
        if (panel.hidden) setOpen(form, true);
        setActive(form, st.active + 1 >= opts.length ? 0 : st.active + 1);
      } else if (e.key === 'ArrowUp' && opts.length) {
        e.preventDefault();
        if (panel.hidden) setOpen(form, true);
        setActive(form, st.active <= 0 ? opts.length - 1 : st.active - 1);
      } else if (e.key === 'Enter' && !panel.hidden && st.active >= 0 && opts[st.active]) {
        e.preventDefault();
        window.location.href = opts[st.active].href;
      }
    });

    document.addEventListener('focusin', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('.hdr-search__input') : null;
      if (!input || !input.form || !enabled(input.form)) return;
      var panel = input.form.querySelector('[data-hdr-panel]');
      if (panel.hidden && panel.firstChild && input.value.trim().length >= 2) setOpen(input.form, true);
    });

    document.addEventListener('click', function (e) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-hdr-panel]:not([hidden])'), function (panel) {
        var form = panel.closest('form');
        if (form && !form.contains(e.target)) setOpen(form, false);
      });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.getAttribute && form.classList.contains('hdr-search__form') && enabled(form)) setOpen(form, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function read(key) {
      try { var v = window.localStorage.getItem(key); return v === null ? -1 : parseInt(v, 10); } catch (e) { return -1; }
    }
    function write(key, v) {
      try { window.localStorage.setItem(key, String(v)); } catch (e) { /* storage not available */ }
    }
    function pick(n, mode, last) {
      if (n < 2) return 0;
      if (mode === 'order') return (last + 1) % n;
      var next = Math.floor(Math.random() * n);
      if (next === last) next = (next + 1 + Math.floor(Math.random() * (n - 1))) % n;
      return next;
    }
    function show(texts, i) {
      Array.prototype.forEach.call(texts, function (t, k) { t.hidden = k !== i; t.removeAttribute('data-rt-fading'); });
    }
    function init(root) {
      if (root.hasAttribute('data-rt-ready')) return;
      var texts = root.querySelectorAll('[data-rt-text]');
      var key = root.getAttribute('data-rt-key') || 'rt';
      var mode = root.getAttribute('data-rt-mode');
      var every = parseInt(root.getAttribute('data-rt-every'), 10) || 0;
      var last = read(key);
      var cur = pick(texts.length, mode, last);
      write(key, cur);
      show(texts, cur);
      root.setAttribute('data-rt-ready', '');
      if (every > 0 && texts.length > 1) {
        setInterval(function () {
          var old = texts[cur];
          old.setAttribute('data-rt-fading', '');
          setTimeout(function () {
            cur = pick(texts.length, mode, cur);
            show(texts, cur);
            var now = texts[cur];
            now.setAttribute('data-rt-fading', '');
            requestAnimationFrame(function () { requestAnimationFrame(function () { now.removeAttribute('data-rt-fading'); }); });
          }, 350);
        }, every * 1000);
      }
    }
    function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-rt]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
